import { useState, useCallback } from "react";

export function useCloudinaryUpload() {
  const [progress, setProgress] = useState(0);
  // const [loadingstate, setLoading] = useState(false);

  const upload = useCallback(async (file) => {
    // setLoading(true);
    setProgress(0);

    const cloudinaryName = process.env.REACT_APP_CLOUDINARY_NAME;

    return new Promise((resolve, reject) => {
      const url = `https://api.cloudinary.com/v1_1/${cloudinaryName}/image/upload`;
      const xhr = new XMLHttpRequest();
      xhr.open("POST", url);

      // Track upload progress
      xhr.upload.addEventListener("progress", (event) => {
        if (event.lengthComputable) {
          const percent = Math.round((event.loaded / event.total) * 100);
          setProgress(percent);
        }
      });

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          // setLoading(false);
          if (xhr.status === 200) {
            const data = JSON.parse(xhr.responseText);
            resolve(data.secure_url);
          } else {
            reject(xhr.responseText);
          }
        }
      };

      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", "sora-ai");
      formData.append("folder", "sora-ai-image");

      xhr.send(formData);
    });
  }, []);

  return { upload, progress, setProgress };
}
